import BookRowRanked from "components/Bookcards/BookRowRanked/BookRowRanked";
import UserBookHighlights from "components/Bookcards/UserBookByStatusCard/UserBookHighlights";
import { LetterbookGoalType, LetterbookSettingType } from "features/Letterbooks/types";

export default function LetterbookGoalRow({
  letterbook,
  settings,
}: {
  letterbook: LetterbookGoalType;
  settings: LetterbookSettingType;
}) {
  const { data } = letterbook;
  const { userBookRead, userBook }  = data;

  if (!userBookRead) {
    return <></>;
  }

  return (
    <BookRowRanked
      size="sm"
      className="py-4 border-b border-gray-300 dark:border-gray-700"
      book={letterbook.book}
      rank={letterbook.position + 1}
      edition={userBookRead?.edition}
      referrerUserId={settings.conditions.referrer_id}
    >
      <UserBookHighlights userBook={userBook} userBookRead={userBookRead} book={letterbook.book} />
    </BookRowRanked>
  );
}
